import moment from 'moment'

export const converterObjActionForObjReduceFormEndereco = (obj, form) => {

  const newForm = { ...form };
  newForm.endereco_logradouro = obj.Logradouro || form.endereco_logradouro;
  newForm.endereco_numero = obj.Numero || form.endereco_numero;
  newForm.endereco_complemento = obj.Complemento || form.endereco_complemento;
  newForm.endereco_bairro = obj.Bairro || form.endereco_bairro;
  newForm.endereco_cidade = obj.Cidade || form.endereco_cidade;
  return newForm;
}

export const converterListActionBancoParaListaComNomeCodigo = (list) => {

  let newList = list.map((val, index, arr) => {

    return { CodigoBanco: val.CodigoBanco, Nome: val.CodigoBanco + " - " + val.Nome };
  });

  return newList;
};

export const converterListActionForListReduceDropdownDadosComplementaresEstadoCivil = (listAction) => {

  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdEstadoCivil, name: val.Nome };
  });

  return newList;
}

export const converterListActionForListReduceDropdownDadosComplementaresGenero = (listAction) => {

  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdGenero, name: val.Nome };
  });

  return newList;
}

export const converterListActionForListReduceDropdownDadosIniciaisPFDocumento = (listAction) => {

  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdTipoDocumento, name: val.Nome };
  });

  return newList;
}

export const converterListActionForListReduceDropdownDadosIniciaisPFOrgaoEmissor = (listAction) => {

  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdOrgaoEmissor, name: val.Descricao };
  });

  return newList;
}

export const converterListActionForListReduceDropdownDadosTipoContaDadosBancario = (listAction) => {
  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdTipoConta, name: val.Nome };
  });

  return newList;
}

export const converterListActionForListReduceDropdownRendaMensal = (listAction) => {

  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdRendaMensal, name: val.Descricao };
  });

  return newList;
}

export const converterListActionForListReduceDropdownPatrimonio = (listAction) => {

  let newList = listAction.map((val, index, arr) => {

    return { value: val.IdPatrimonio, name: val.Descricao };
  });

  return newList;
}

export const converterObjActionForObjReduceFileUploadDocumentosAnexos = (obj) => {
  return {
    IdTipoArquivo: obj.fileType,
    IdTipoDocumento: obj.documentType,
    IdGrupoDocumento: obj.idGrupoDocumento,
    IdTipoDocumentoImagem: obj.imageType,
    Arquivo: obj.base64,
    DescricaoDocumento: obj.id
  };
}

const checkField = (fields, field) => {
  //  let steps = props.currentStep.Campos.filter(e=>e);
  return fields.find((c) => {
    return c.chave === field;
  })
}

export const removeMask = value => {

  if (value) {
    value = value.replace(' ', '');
    // eslint-disable-next-line no-useless-escape
    return value.replace(/\/|\-|\.|\(|\)|\+/g, '')
  }

}

export const makeDate = (date) => {
  if (date === undefined || date === null || date.replace(' ', '').length === 0) {
    return null;
  }

  return moment(date, "DD/MM/YYYY").format()
}

export const converterObjResumoForObjAction = (obj) => {
  let { Campos } = obj.navegationStepsReducer.currentStep;
  let formTipoCadastro = obj.tipoCadastroReducer;
  let { formPF } = obj.dadosIniciaisPFReducer;
  let { formPJ } = obj.dadosIniciaisPJReducer;
  let { formEndereco, endereco_estado, endereco_pais, typeaHeadEnderecoEstadoList, endereco_idDDDpais } = obj.enderecoReducer;
  const { listPais } = obj.ddiReducer
  let { formDados } = obj.dadosComplementaresReducer;
  let { formMaisDetalhes } = obj.maisDetalhesReducer;
  let { formDeclaracaoPF } = obj.declaracaoEspecificaReducer;
  let { formDeclaracaoPJ } = obj.declaracaoEspecificaReducer;
  let { formDadosBancarios } = obj.dadosBancarioReducer;
  let formResumo = obj.resumoReducer;

  const documentoArquivo = [
    ...obj.documentosAnexosReducer.documentos_documentoIdentificacaoFrente.documents,
    ...obj.documentosAnexosReducer.documentos_documentoIdentificacaoVerso.documents,
    ...obj.documentosAnexosReducer.documentos_comprovanteResidenciaComprovante.documents,
    ...obj.documentosAnexosReducer.documentos_comprovanteRendaComprovante.documents,
    ...obj.documentosAnexosReducer.documentos_estatutoPessoaJuridicaNacional.documents,
    ...obj.documentosAnexosReducer.documentos_procuracaoPessoaJuridicaEstrangeira.documents,
    ...obj.documentosAnexosReducer.documentos_procuracaoComprovante.documents,
    ...obj.documentosAnexosReducer.documentos_contratoSocialComprovante.documents,
    ...obj.documentosAnexosReducer.documentos_balancoPatrimonial.documents,
    ...obj.documentosAnexosReducer.documentos_faturamentoUltimosMeses.documents,
    ...obj.documentosAnexosReducer.documentos_IRPF.documents,
  ];

  obj.documentosAnexosReducer.documentosSocioDezOuMais.forEach((s) => {
    documentoArquivo.push(...s.documentos_comprovanteRendaSocioPessoaFisicaDezOuMais.documents);
  });

  let tipoPessoaId = 0;
  let codigoGerente;

  switch (obj.tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica":
      tipoPessoaId = 1;
      codigoGerente = formPF.dadosIniciais_codigoGerente;
      break;
    case "PessoaJuridica":
      tipoPessoaId = 2;
      codigoGerente = formPJ.dadosIniciais_codigoGerente;
      break;
    case "PessoaEstrangeira":
      tipoPessoaId = 3;
      break;
    default:
  }

  let req = {};
  req.IdTipoCliente = tipoPessoaId;
  req.CodigoGerente = codigoGerente;
  req.TipoCadastro = formTipoCadastro.tipoContrato;
  req.MotivoCadastro = formMaisDetalhes.maisDetalhes_field;
  let tipoNecessidadeId = 0;

  switch (obj.tipoCadastroReducer.tipoNecessidade) {
    case "EnviarParaExterior":
      tipoNecessidadeId = 1;
      break;
    case "ReceberDoExterior":
      tipoNecessidadeId = 2;
      break;
    default:
  }

  req.IdTipoNecessidadeTransferencia = tipoNecessidadeId;

  req.Produtos = [{
    IdProduto: formTipoCadastro.tipoProdutoValue
  }]

  if (tipoPessoaId === 2) {
    let pessoaJuridica = {}
    req.PessoaJuridica = pessoaJuridica;
    if (checkField(Campos, "endereco_telefoneFixo")) {
      pessoaJuridica.TelefoneFixo = removeMask(formEndereco.endereco_telefoneFixo);
      if (pessoaJuridica.TelefoneFixo !== null && pessoaJuridica.TelefoneFixo !== "")
        pessoaJuridica.CodigoIsoPaisTelefone = removeMask(endereco_idDDDpais);
      else
        pessoaJuridica.CodigoIsoPaisTelefone = null;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_pessoaAmericana")) {
      pessoaJuridica.PessoaAmericana = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_pessoaAmericana;
    }
    if (checkField(Campos, "dadosIniciais_cnpj")) {
      pessoaJuridica.CNPJ = removeMask(formPJ.dadosIniciais_cnpj);
    }
    if (checkField(Campos, "dadosIniciais_cnae")) {
      pessoaJuridica.CNAE = formPJ.dadosIniciais_cnae ? formPJ.dadosIniciais_cnae.Codigo : null;
    }
    if (checkField(Campos, "dadosIniciais_razaoSocial")) {
      pessoaJuridica.RazaoSocial = formPJ.dadosIniciais_razaoSocial;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_participanteGiin")) {
      pessoaJuridica.NumeroGIIN = formDeclaracaoPJ.declaracoesEspecificasObrigatorias_participanteGiin;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_declaracaoAnual")) {
      pessoaJuridica.IdDeclaracaoAnual = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_declaracaoAnual;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_nif")) {
      pessoaJuridica.NIF = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_nif;
    }
    if (checkField(Campos, "dadosIniciais_nomeContato")) {
      pessoaJuridica.NomeContato = formPJ.dadosIniciais_nomeContato;
    }
    if (checkField(Campos, "dadosIniciais_emailContato")) {
      pessoaJuridica.EmailContato = formPJ.dadosIniciais_emailContato;
    }
    if (checkField(Campos, "dadosIniciais_telefoneContato")) {
      pessoaJuridica.TelefoneContato = removeMask(formPJ.dadosIniciais_telefoneContato);
      pessoaJuridica.CodigoIsoPaisTelefoneContato = removeMask(obj.dadosIniciaisPJReducer.dadosIniciais_idDDDpais);
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_participanteFatca")) {
      pessoaJuridica.ParticipanteFatca = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_participanteFatca;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_socioPpe")) {
      pessoaJuridica.PossuiPPE = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_socioPpe;
    }
    if (checkField(Campos, "dadosIniciais_cpfContato")) {
      pessoaJuridica.CPFContato = removeMask(formPJ.dadosIniciais_cpfContato);
    }

    const socios = [];
    obj.associadoPJReducer.forEach((a) => {
      socios.push({
        IdTipoSocio: a.tipoSocio,
        IdCliente: a.IdCliente,
        DadosCadastrais: a.dadosCadastrais && converterObjAssociadoForObjAction(a.dadosCadastrais, listPais, a.camposResumo)
      });
    });
    req.PessoaJuridica.Socios = socios;

  } else {

    let pessoaFisica = {}
    req.PessoaFisica = pessoaFisica;

    if (checkField(Campos, "declaracoesEspecificasObrigatorias_pessoaAmericana")) {
      pessoaFisica.PessoaAmericana = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_pessoaAmericana;
    }
    if (checkField(Campos, "dadosComplementares_paisFiscal")) {
      pessoaFisica.IdPaisFiscal = obj.dadosComplementaresReducer.dadosComplementares_paisFiscal;
    }
    if (checkField(Campos, "dadosComplementares_PaisNascimento")) {
      pessoaFisica.IdPaisNascimento = obj.dadosComplementaresReducer.dadosComplementares_PaisNascimento;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_ocupacaoPrincipal")) {
      pessoaFisica.Profissao = formDeclaracaoPF.declaracoesEspecificasObrigatorias_ocupacaoPrincipal;
    }
    if (checkField(Campos, "endereco_telefoneFixo")) {
      pessoaFisica.TelefoneFixo = removeMask(formEndereco.endereco_telefoneFixo);
      if (pessoaFisica.TelefoneFixo !== null && pessoaFisica.TelefoneFixo !== "")
        pessoaFisica.CodigoIsoPaisTelefone = removeMask(endereco_idDDDpais);
      else
        pessoaFisica.CodigoIsoPaisTelefone = null;
    }
    if (checkField(Campos, "dadosIniciais_nomeCompleto")) {
      pessoaFisica.NomeCompleto = formPF.dadosIniciais_nomeCompleto;
    }
    if (checkField(Campos, "dadosIniciais_nomeSocial")) {
      pessoaFisica.NomeSocial = formPF.dadosIniciais_nomeSocial;
    }
    if (checkField(Campos, "dadosIniciais_cpf")) {
      pessoaFisica.CPF = removeMask(formPF.dadosIniciais_cpf);
    }
    if (checkField(Campos, "dadosComplementares_estadoCivil")) {
      pessoaFisica.IdEstadoCivil = parseInt(obj.dadosComplementaresReducer.dadosComplementares_estadoCivil);
    }

    pessoaFisica.IdGenero = obj.dadosComplementaresReducer.dadosComplementares_genero;

    if (checkField(Campos, "dadosComplementares_nomeConjuge")) {
      pessoaFisica.NomeConjuge = formDados.dadosComplementares_nomeConjuge;
    }
    if (checkField(Campos, "dadosComplementares_cpfConjuge")) {
      pessoaFisica.CPFConjuge = removeMask(formDados.dadosComplementares_cpfConjuge);
    }
    if (checkField(Campos, "dadosComplementares_dataNascimentoConjuge")) {
      pessoaFisica.DataNascimentoConjuge = makeDate(formDados.dadosComplementares_dataNascimentoConjuge);
    }
    if (checkField(Campos, "dadosComplementares_nomeMae")) {
      pessoaFisica.NomeMae = formDados.dadosComplementares_nomeMae;
    }
    if (checkField(Campos, "dadosComplementares_nomePai")) {
      pessoaFisica.NomePai = formDados.dadosComplementares_nomePai;
    }
    if (checkField(Campos, "dadosComplementares_SocialSecurityNumber")) {
      pessoaFisica.SocialSecurityNumber = formDados.dadosComplementares_SocialSecurityNumber;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_faixaRendaMensal")) {
      pessoaFisica.IdRendaMensal = parseInt(obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_faixaRendaMensal);
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_faixaPatrimonio")) {
      pessoaFisica.IdPatrimonio = parseInt(obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_faixaPatrimonio);
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_ppe")) {
      pessoaFisica.SouPPE = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_ppe;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_relacaoPessoaPpe")) {
      pessoaFisica.RelacionamentoPPE = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_relacaoPessoaPpe;
    }
    if (checkField(Campos, "dadosIniciais_email")) {
      pessoaFisica.Email = formPF.dadosIniciais_email;
    }
    if (checkField(Campos, "dadosIniciais_telefoneCelular")) {
      pessoaFisica.telefoneCelular = removeMask(formPF.dadosIniciais_telefoneCelular);
      pessoaFisica.CodigoIsoPaisCelular = removeMask(obj.dadosIniciaisPFReducer.dadosIniciais_idDDDpais);
    }
    if (checkField(Campos, "dadosIniciais_dataNascimento")) {
      pessoaFisica.DataNascimento = makeDate(formPF.dadosIniciais_dataNascimento);
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_nif")) {
      pessoaFisica.NIF = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_nif;
    }
    if (checkField(Campos, "declaracoesEspecificasObrigatorias_nifCountry")) {
      pessoaFisica.NIFCountry = obj.declaracaoEspecificaReducer.declaracoesEspecificasObrigatorias_nifCountry;
    }

    let documento = {}
    pessoaFisica.Documento = documento;
    if (checkField(Campos, "dadosIniciais_numeroDocumento")) {
      documento.NumeroDocumento = formPF.dadosIniciais_numeroDocumento
    }
    if (checkField(Campos, "dadosIniciais_orgaoEmissor")) {
      documento.IdOrgaoEmissor = formPF.dadosIniciais_orgaoEmissor
    }
    if (checkField(Campos, "dadosIniciais_dataEmissao")) {
      documento.DataEmissao = makeDate(formPF.dadosIniciais_dataEmissao)
    }
    if (checkField(Campos, "dadosIniciais_dataVencimento")) {
      documento.DataVencimento = makeDate(formPF.dadosIniciais_dataVencimento)
    }
    if (checkField(Campos, "dadosIniciais_paisDocumento")) {
      documento.IdPais = obj.dadosIniciaisPFReducer.dadosIniciais_paisDocumento
    }
    if (checkField(Campos, "dadosIniciais_tipoDocumento")) {
      documento.IdTipoDocumento = parseInt(obj.dadosIniciaisPFReducer.dadosIniciais_tipoDocumento)
    }
  }

  req.DocumentoArquivo = documentoArquivo;

  let endereco = {}
  req.Endereco = endereco;

  if (checkField(Campos, "endereco_pais")) {
    endereco.IdPais = endereco_pais;
    let endereco_paisResult = listPais.filter(function (el) {
      return el.IdPais === endereco_pais;
    });
    endereco.NomePais = endereco_paisResult.length > 0 ? endereco_paisResult[0].Nome : "";
  }
  if (checkField(Campos, "endereco_cep")) {
    endereco.CEP = removeMask(formEndereco.endereco_cep);
  }
  if (checkField(Campos, "endereco_bairro")) {
    endereco.Bairro = formEndereco.endereco_bairro;
  }
  if (checkField(Campos, "endereco_logradouro")) {
    endereco.Logradouro = formEndereco.endereco_logradouro;
  }
  if (checkField(Campos, "endereco_provincia")) {
    endereco.Provincia = formEndereco.endereco_provincia;
  }
  if (checkField(Campos, "endereco_cidade")) {
    endereco.Cidade = formEndereco.endereco_cidade;
  }
  if (checkField(Campos, "endereco_estado")) {

    if (endereco_estado === null) {
      endereco.IdEstado = null
    } else {
      let estadoResult = typeaHeadEnderecoEstadoList.filter(function (el) {
        return el.IdEstado === endereco_estado;
      });
      endereco.IdEstado = parseInt(estadoResult[0].IdEstado);
    }
  }
  if (checkField(Campos, "endereco_complemento")) {
    endereco.Complemento = formEndereco.endereco_complemento;
  }
  if (checkField(Campos, "endereco_numero")) {
    endereco.Numero = formEndereco.endereco_numero;
  }

  if (formDadosBancarios) {
    if (formDadosBancarios.dadosBancarios_Agencia) {
      req.Conta = {
        Agencia: formDadosBancarios.dadosBancarios_Agencia,
        Numero: formDadosBancarios.dadosBancarios_Conta,
        CodigoBanco: formDadosBancarios.dadosBancarios_Banco,
        IdTipoConta: parseInt(formDadosBancarios.dadosBancarios_TipoConta)
      }
    }
  }

  req.AceiteTermos = formResumo.resumo_check1 && formResumo.resumo_check2;

  return req;
}

export const converterObjAssociadoForObjAction = (dadosCadastrais, listPais, Campos) => {
  const {
    tipoCadastro,
    dadosIniciais,
    declaracoesEspecificas,
    documentosAnexos,
  } = dadosCadastrais;

  const req = {};
  req.IdTipoCliente = 1;
  req.CodigoGerente = dadosIniciais.form.dadosIniciais_codigoGerente;
  req.TipoCadastro = "Pessoa física com pretensão de receber valores do exterior, até USD 10.000,00 mês ou até USD 20.000,00 ano¹."
  req.MotivoCadastro = '';
  req.IdTipoNecessidadeTransferencia = 2;
  req.Produtos = [{
    IdProduto: tipoCadastro.tipoProdutoValue,
  }]

  req.PessoaFisica = {};
  if (checkField(Campos, "dadosIniciais_nomeCompleto")) {
    req.PessoaFisica.NomeCompleto = dadosIniciais.form.dadosIniciais_nomeCompleto;
  }
  if (checkField(Campos, "dadosIniciais_nomeSocial")) {
    req.PessoaFisica.NomeSocial = dadosIniciais.form.dadosIniciais_nomeSocial;
  }
  if (checkField(Campos, "dadosIniciais_cpf")) {
    req.PessoaFisica.CPF = removeMask(dadosIniciais.form.dadosIniciais_cpf);
  }
  if (checkField(Campos, "dadosIniciais_email")) {
    req.PessoaFisica.Email = dadosIniciais.form.dadosIniciais_email;
  }
  if (checkField(Campos, "dadosIniciais_telefoneCelular")) {
    req.PessoaFisica.telefoneCelular = removeMask(dadosIniciais.form.dadosIniciais_telefoneCelular);
    req.PessoaFisica.CodigoIsoPaisCelular = removeMask(dadosIniciais.dadosIniciais_idDDDpais);
  }
  if (checkField(Campos, "dadosIniciais_dataNascimento")) {
    req.PessoaFisica.DataNascimento = makeDate(dadosIniciais.form.dadosIniciais_dataNascimento);
  }

  if (checkField(Campos, "declaracoesEspecificasObrigatorias_faixaRendaMensal")) {
    req.PessoaFisica.IdRendaMensal = parseInt(declaracoesEspecificas.form.declaracoesEspecificasObrigatorias_faixaRendaMensal);
  }
  if (checkField(Campos, "declaracoesEspecificasObrigatorias_faixaPatrimonio")) {
    req.PessoaFisica.IdPatrimonio = parseInt(declaracoesEspecificas.form.declaracoesEspecificasObrigatorias_faixaPatrimonio);
  }

  req.DocumentoArquivo = [
    ...documentosAnexos.documentos_documentoIdentificacaoFrente.documents,
    ...documentosAnexos.documentos_documentoIdentificacaoVerso.documents,
    ...documentosAnexos.documentos_comprovanteResidenciaComprovante.documents,
  ];

  req.AceiteTermos = true;

  return req;
}

export const converterObjActionForObjReduceDadosIniciaisPj = (documento, idTipoCliente) => {

  return {
    IdTipoCliente: idTipoCliente,
    Documento: documento
  }
}

export const converterObjActionForObjReduceDadosIniciaisPF = (dataNascimento, documento, idTipoCliente) => {

  return {
    IdTipoCliente: idTipoCliente,
    Documento: documento,
    DataNascimento: dataNascimento
  }
}